<template>
  <div class="t-calendar__forms">
    <transition name="fade">
      <form class="t-addLesson" v-show="add_form" @submit.prevent="SubmitAdd">
        <span class="t-addLesson__close" @click.prevent="CloseFormLocal()"></span>
        <h2>{{ calendarText.addLessonTitle }}</h2>
        <div class="t-input">
          <label>{{ calendarText.addLessonForm }}</label>
          <v-select v-if="!mobileCalendar" v-model="time"
                    :options="optionsAdd"
                    :searchable="false"
                    :filterable="false"></v-select>

          <div v-else class="t-selectMobile-container">
            <select v-model="time" class="t-selectMobile">
              <option v-for="item in optionsAdd" :value="item" >{{ item.label }}</option>
            </select>
            <img class="t-selectMobile-time" src="/img/time.png">
          </div>
          <span>- {{ time_end }}</span>
        </div>
        <div class="t-input" v-if="otherLessons.length">
          <label>{{ calendarText.addLessonOtherLessons }}</label>
          <div class="t-otherLessonContainer">
            <div>
              <router-link v-for="(item, index) in otherLessonsActive" :to="'/courses/' + item.id + '/' + item.slug" target="_blank"
                          class="t-addLesson__other" :key="index" :title="item.val">{{ item.val }}
              </router-link>
            </div>
          </div>
        </div>

        <!--<button class="t-addLesson__deleteBtn">-->
          <!--<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">-->
            <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M20.999 12C20.999 11.4477 20.5513 11 19.999 11C19.4467 11 18.999 11.4477 18.999 12V13H14.999C14.4467 13 13.999 13.4477 13.999 14C13.999 14.5523 14.4467 15 14.999 15H19.999H24.999C25.5513 15 25.999 14.5523 25.999 14C25.999 13.4477 25.5513 13 24.999 13H20.999V12ZM13.999 16C13.7025 16 13.4213 16.1316 13.2313 16.3593C13.0413 16.5869 12.9621 16.8871 13.0152 17.1789L13.7424 21.1789L14.4697 25.1789L15.0152 28.1789C15.1016 28.6544 15.5157 29 15.999 29H23.999C24.4823 29 24.8964 28.6544 24.9829 28.1789L26.2556 21.1789L26.9829 17.1789C27.0359 16.8871 26.9568 16.5869 26.7668 16.3593C26.5768 16.1316 26.2956 16 25.999 16H13.999ZM15.5609 20L15.1972 18H24.8008L24.4372 20H15.5609ZM16.2882 24L15.9245 22H24.0735L23.7099 24H16.2882ZM16.8336 27L16.6518 26H23.3463L23.1645 27H16.8336Z" fill="#52A8F2"/>-->
          <!--</svg>-->
        <!--</button>-->
        <div class="t-btn-wrapper">
          <button class="t-btn"><span>{{ calendarText.addLessonBtn }}</span></button>
          <button v-if="mobileCalendar" class="t-btn t-btn_white" @click.prevent="OpenEdit()"><span>{{ calendarText.change }}</span></button>
        </div>
      </form>
    </transition>
    <transition name="fade">
      <!-- форма изменения даты для курса -->
      <form class="t-addLesson" v-show="edit_form" @submit.prevent="UpdateLessons">
        <span class="t-addLesson__close" @click.prevent="CloseFormLocal()"></span>
        <h2>{{ calendarText.editLesson }}</h2>
        <div class="t-addLesson__wrapper">
          <div class="t-input" :class="{_disabled: !lesson.update}" v-for="(lesson, index) in lessons_in_day" :key="index">
                                <!-- @input="ChangeSelect(lesson)" -->
            <div v-if="lesson_type === 3" class="t-addLesson__title">{{calendarText.stream + ' ' + parseInt(lesson.streamId || lesson.localStreamIndex) }} {{calendarText.lesson + ' ' + parseInt(lesson.lesson + 1)}}</div>
            <v-select v-if="!mobileCalendar" v-model="lesson.value"
                      :options="optionsEdit"
                      @search:focus="SetLesson(lesson)"
                      :searchable="false"
                      :filterable="false"></v-select>
            <div v-else class="t-selectMobile-container">
              <select v-model="lesson.value" class="t-selectMobile" @focus="SetLesson(lesson)">
                <option selected>{{ lesson.value }}</option>
                <option v-for="item in optionsEdit">{{ item }}</option>
              </select>
              <img class="t-selectMobile-time" src="/img/time.png">
            </div>

            <button v-if="lesson_type === 3" class="t-addLesson__del" @click.prevent="changeLessonDate(lesson)">
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 16H1V12M5 16V12H1M5 16L14 7M1 12L10 3M10 3L12 1L16 5L14 7M10 3L14 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button v-if="lesson_type == 3" class="t-addLesson__del" @click.prevent="DelCourseModalOpnen(lesson)">
              <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99831 1C8.99831 0.447266 8.55105 0 7.99831 0C7.62136 0 7.29324 0.207031 7.12331 0.513672C7.04324 0.658203 6.99831 0.824219 6.99831 1V2H2.99831C2.44558 2 1.99831 2.44727 1.99831 3C1.99831 3.55273 2.44558 4 2.99831 4H7.99831H12.9983C13.551 4 13.9983 3.55273 13.9983 3C13.9983 2.44727 13.551 2 12.9983 2H8.99831V1ZM1.99831 5C1.70144 5 1.42019 5.13086 1.23074 5.35938C1.04128 5.58594 0.961205 5.88672 1.01394 6.17969L1.74245 10.1797L2.46902 14.1797L3.01394 17.1797C3.10183 17.6543 3.51589 18 3.99831 18H11.9983C12.4807 18 12.8948 17.6543 12.9827 17.1797L14.2542 10.1797L14.9827 6.17969C15.012 6.01367 15.0003 5.8457 14.9495 5.68945C14.9104 5.57031 14.8479 5.45703 14.7659 5.35938C14.5764 5.13086 14.2952 5 13.9983 5H1.99831ZM3.56081 9L3.19558 7H12.801L12.4358 9H3.56081ZM4.28738 13L3.9241 11H12.0725L11.7093 13H4.28738ZM4.8323 16L4.65066 15H11.346L11.1643 16H4.8323Z" fill="#52A8F2"/>
              </svg>
            </button>
            <button v-else-if="lesson.update" class="t-addLesson__del" @click.prevent="Del(lesson)">
              <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99831 1C8.99831 0.447266 8.55105 0 7.99831 0C7.62136 0 7.29324 0.207031 7.12331 0.513672C7.04324 0.658203 6.99831 0.824219 6.99831 1V2H2.99831C2.44558 2 1.99831 2.44727 1.99831 3C1.99831 3.55273 2.44558 4 2.99831 4H7.99831H12.9983C13.551 4 13.9983 3.55273 13.9983 3C13.9983 2.44727 13.551 2 12.9983 2H8.99831V1ZM1.99831 5C1.70144 5 1.42019 5.13086 1.23074 5.35938C1.04128 5.58594 0.961205 5.88672 1.01394 6.17969L1.74245 10.1797L2.46902 14.1797L3.01394 17.1797C3.10183 17.6543 3.51589 18 3.99831 18H11.9983C12.4807 18 12.8948 17.6543 12.9827 17.1797L14.2542 10.1797L14.9827 6.17969C15.012 6.01367 15.0003 5.8457 14.9495 5.68945C14.9104 5.57031 14.8479 5.45703 14.7659 5.35938C14.5764 5.13086 14.2952 5 13.9983 5H1.99831ZM3.56081 9L3.19558 7H12.801L12.4358 9H3.56081ZM4.28738 13L3.9241 11H12.0725L11.7093 13H4.28738ZM4.8323 16L4.65066 15H11.346L11.1643 16H4.8323Z" fill="#52A8F2"/>
              </svg>
            </button>
          </div>
        </div>

        <div class="t-btn-wrapper">
          <button class="t-btn"><span>{{ calendarText.addLessonBtn }}</span></button>
          <button v-if="mobileCalendar" class="t-btn t-btn_white" @click.prevent="CloseFormLocal()"><span>{{ calendarText.cancel }}</span></button>
        </div>
      </form>
    </transition>
    <!-- форма подтверждения удаления курса -->
    <transition name="fade">
      <!-- @submit.prevent="DelCourse()" -->
      <form class="t-addLesson" v-show="del_course_form" @submit.prevent="DelCourse(currentStream)">
        <span class="t-addLesson__close" @click.prevent="CloseFormLocal()"></span>
        <h2>{{ calendarText.deleteStreamTitle }}</h2>
        <p class="t-addLesson__title t-addLesson__title-text">{{ calendarText.deleteStream1 }}{{ currentStreamObj.streamId || currentStreamObj.localStreamIndex  }}{{ calendarText.deleteStream2 }}</p>
        <button class="t-btn t-btn_full t-btn_m_b" @click.prevent="CloseFormLocal()"><span>{{ calendarText.cancel }}</span></button>
        <button class="t-btn t-btn_white t-btn_full"><span>{{ calendarText.delete }}</span></button>
      </form>
    </transition>
    <!-- форма изменения даты для курса -->
    <transition name="fade">
      <form class="t-addLesson" v-show="change_form" @submit.prevent="changeDate()">
        <span class="t-addLesson__close" @click.prevent="CloseFormLocal(true)"></span>
        <h2>{{ calendarText.changeDate }}</h2>
        <p class="t-addLesson__textStream">{{ titleStream }}</p>
        <div class="t-input t-input__change">
          <label>{{ calendarText.changeDateLesson }}</label>
          <div class="t-input"  :class="{_error: error}">
            <!--<imask-input v-model="selectDay" :mask="maskDate" :min="minChangeDate"/>-->
            <!-- <imask-input v-model="selectDay" :mask="maskDate" :min="minChangeDate" @change="changeInputDate()"/> -->
            <date-picker
              v-model="selectDay"
              @change="changeInputDate()"
              :not-before="new Date()"
              :first-day-of-week="1"
              lang="ru"
              format="DD.MM.YYYY"
              :clearable="false" width="100%"></date-picker>
          </div>
          <!--<cmp-calendar v-if="openCalendar" @selectDate="selectDate" :select="selectDay" class="t-calendar_changeDate"></cmp-calendar>-->
        </div>

        <div v-if="value !== ''" class="t-input">
          <label>{{ calendarText.addLessonForm }}</label>
          <v-select v-if="!mobileCalendar" v-model="value"
                    :options="optionsEdit"
                    :searchable="false"
                    :filterable="false"></v-select>

          <div v-else class="t-selectMobile-container">
            <select v-model="value" class="t-selectMobile">
              <option selected>{{ value }}</option>
              <option v-for="item in optionsEdit">{{ item }}</option>
            </select>
            <img class="t-selectMobile-time" src="/img/time.png">
          </div>

        </div>
        <div class="t-input" v-if="otherLessons.length">
          <label>{{ calendarText.addLessonOtherLessons }}</label>
          <div class="t-otherLessonContainer">
            <div>
              <router-link v-for="(item, index) in otherLessonsActive" :to="'/courses/' + item.id + '/' + item.slug" target="_blank"
                          class="t-addLesson__other" :key="index" :title="item.val">{{ item.val }}
              </router-link>
            </div>
          </div>
        </div>

        <div class="t-btn-wrapper">
          <button class="t-btn"><span>{{ calendarText.addLessonBtn }}</span></button>
          <button v-if="mobileCalendar" class="t-btn t-btn_white" @click.prevent="CloseFormLocal()"><span>{{ calendarText.cancel }}</span></button>
        </div>
      </form>
    </transition>
  </div>
</template>

<script>

    import {mapActions, mapGetters} from 'vuex';
    //import Calendar from '../../Calendar_modal/Calendar.vue';
    import {IMaskComponent} from 'vue-imask';
    import DatePicker from 'vue2-datepicker'

    export default {
        props: ['lessons', 'lesson_type', 'lesson_index', 'course'],
        data(){
            return {
                time: {label: '00:00', value: 0},
                otherLessons: [],
                lessons_in_day: [],
                lesson_in_day_before: {
                  value : '00:00-00:00'
                },

                // del_course_form: false,
                // change_form: false,
                titleStream: '',
                //openCalendar: false,
                currentLesson: null,
                currentStream: null,
                currentLessonId: null,
                currentStreamObj: {
                  streamId: null,
                  localStreamIndex: null
                },
                selectDay: '',
                value: '',
                maskDate: Date,
                error: false,
            }
        },
        components: {
            // 'cmp-calendar': Calendar,
            'imask-input': IMaskComponent,
            DatePicker,
        },
        computed: {
            ...mapGetters(['mobileCalendar']),
            ...mapGetters('calendar', ['open_day', 'date_active', 'add_form', 'edit_form', 'del_course_form', 'change_form', 'day_week', 'type', 'days_before', 'day_in_month', 'days_after', 'date_active', 'day_week_header', 'calendarText']),
            ...mapGetters('coursesList', ['streamsMy', 'streamsEntries']),
            // minChangeDate() {
            //     let d = new Date();
            //     return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            // },
            time_end(){
                let minutes = this.time.value;
                minutes += this.lessons[this.lesson_index].duration.value.minute;
                let hours = Math.floor(minutes / 60);
                minutes -= hours * 60;

                if(hours > 24 || ( hours == 24 && minutes > 0) ){ // означает что это часы на следующий день
                    hours -= 24;
                }

                if(hours < 10)
                    hours = '0' + hours;
                if(minutes < 10)
                    minutes = '0' + minutes;

                return hours + ':' + minutes
            },
            block_time(){
                let bt = [];
                // для проверки сегодняшний ли день
                let date = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.open_day;
                let today = new Date(),
                    today_text = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();
                if ( today_text === date) {
                    // если пользователь захочет добавить урок на сегодня 
                    // ограничить выбор времени от текущего
                    let hours = today.getHours();
                    let minutes = today.getMinutes();
                    let start = 0;
                    let end = hours*60 + minutes
                    bt.push({
                        min: start,
                        max: end
                    })
                }
                if (this.lesson_in_day_before){
                    let value = this.lesson_in_day_before.value;
                    let start = 0 + parseInt(value.split('-')[0].split(':')[0])*60 + parseInt(value.split('-')[0].split(':')[1]);
                    // let end = 0 + parseInt(value.split('-')[1].split(':')[0])*60 + parseInt(value.split('-')[1].split(':')[1]);
                    let end = start + parseInt(this.lesson_in_day_before.duration);
                    if (end > 1440){
                      bt.push({ 
                          min: 0,
                          max: end - 1440
                      })
                    }
                }

                for (let j = 0; j < this.lessons_in_day.length; j++) {
                    let value = this.lessons_in_day[j].value;
                    let start = 0 + parseInt(value.split('-')[0].split(':')[0])*60 + parseInt(value.split('-')[0].split(':')[1]);
                    // let end = 0 + parseInt(value.split('-')[1].split(':')[0])*60 + parseInt(value.split('-')[1].split(':')[1]);
                    let end = start + parseInt(this.lessons_in_day[j].duration);
                    bt.push({
                        min: start,
                        max: end
                    })
                }
                // console.log('otherLessonsActive block_time', this.otherLessonsActive)
                // console.log('otherLessonsActive course', this.course)

                for (let j = 0; j < this.otherLessonsActive.length; j++) {
                    if (this.course === undefined || this.otherLessonsActive[j].id != this.course.id) {
                      let value = this.otherLessonsActive[j].value;
                      let start = 0 + parseInt(value.split('-')[0].split(':')[0])*60 + parseInt(value.split('-')[0].split(':')[1]);
                      let end = 0 + parseInt(value.split('-')[1].split(':')[0])*60 + parseInt(value.split('-')[1].split(':')[1]);
                      bt.push({
                          min: start,
                          max: end
                      })
                    }
                }

              // console.log('block_time', bt)
                return bt
            },
            optionsAdd(){
                let block_time = this.block_time;
                let lesson_index = this.lesson_index;
                let options = [];

                let duration = parseInt(this.lessons[this.lesson_index].duration.value.minute);
                for(let start = 0; start <= 1410; start += 30){
                    let addTime = true;

                    for(let b = 0; b < block_time.length; b++){
                        if(block_time[b].min <= start + duration && block_time[b].max > start ){
                            // // console.log('start', start)
                            // // console.log('duration', duration)
                            addTime = false;
                            break;
                        } else{
                            addTime = true;
                        }
                    }

                    if(addTime){
                        let hours = Math.floor(start/60);
                        let minutes = start - hours * 60;
                        let time = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);

                        options.push({
                            label: time, value: start
                        })
                    } 
                }
                if(options.length){
                    this.time = options[0];
                } else {
                    if(this.add_form){
                        this.CloseFormLocal();
                        this.showMsg('Весь день загружен! Вы не можете больше создавать сегодня уроков такой длинны.')
                    } 
                }


                return options
            },

            otherLessonsActive() {
                return this.otherLessons.filter((i) => {
                    return i.id !== null;
                });
            },
            optionsEdit(){
                let lesson = this.currentLesson;
                let block_time = this.block_time;
                //let lesson_index = this.lesson_index;
                let duration = lesson ? parseInt(this.lessons[lesson].duration.value.minute): 30;

                let options = [];
                for(let start = 0; start <= 1410; start += 30){
                    let addTime = true;

                    for(let b = 0; b < block_time.length; b++){
                        if(block_time[b].min < start + duration - 1 && block_time[b].max > start){
                            addTime = false;
                            break;
                        } else{
                            addTime = true;
                        }
                    }

                    if(addTime){
                        let hours = Math.floor(start/60);
                        let minutes = start - hours * 60;
                        let time = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);

                        minutes = start + duration;
                        hours = Math.floor(minutes/60);
                        minutes = minutes - hours * 60;

                        if(hours > 24 || ( hours == 24 && minutes > 0) ){ // означает что это часы на следующий день
                            hours -= 24;
                        }

                        time += '-';

                        time += hours < 10 ? ('0' + hours) : hours;
                        time += ':';
                        time += minutes < 10 ? ('0' + minutes) : minutes;

                        // if(hours <= 23)
                            options.push(time);
                    }
                }
                return options
            },
        },
        watch: {
            add_form(){
                if(this.open_day !== null && this.add_form){
                    this.updateTime(false);
                    this.UpdateLessonInDay(false);
                    document.addEventListener('click', this.closeModalFormMissClick);
                    document.addEventListener('keyup', this.closeModalFormEsc);
                } else {
                    document.removeEventListener('click', this.closeModalFormMissClick);
                    document.removeEventListener('keyup', this.closeModalFormEsc);
                }
            },
            edit_form(){
                if(this.open_day !== null && this.edit_form){
                    this.updateTime(false);
                    this.UpdateLessonInDay(false);
                    document.addEventListener('click', this.closeModalFormMissClick);
                    document.addEventListener('keyup', this.closeModalFormEsc);
                } else {
                    document.removeEventListener('click', this.closeModalFormMissClick);
                    document.removeEventListener('keyup', this.closeModalFormEsc);
                }
            },
            del_course_form(){
                if(this.open_day !== null && this.del_course_form){
                    this.updateTime(false);
                    this.UpdateLessonInDay(false);
                    document.addEventListener('click', this.closeModalFormMissClick);
                    document.addEventListener('keyup', this.closeModalFormEsc);
                } else {
                    document.removeEventListener('click', this.closeModalFormMissClick);
                    document.removeEventListener('keyup', this.closeModalFormEsc);
                }
            },
            change_form(){
                if(this.open_day !== null && this.change_form){
                    this.updateTime(false);
                    this.UpdateLessonInDay(false);
                    document.addEventListener('click', this.closeModalFormMissClick);
                    document.addEventListener('keyup', this.closeModalFormEsc);
                } else {
                    document.removeEventListener('click', this.closeModalFormMissClick);
                    document.removeEventListener('keyup', this.closeModalFormEsc);
                }
            },
        },
        created(){
          
        },
        methods: {
            ...mapActions('msg', ['showMsg']),
            ...mapActions('calendar', ['GoTo', 'CloseForm', 'OpenEditForm', 'OpenChangeForm', 'OpenDelCourseForm']),
            CloseFormLocal(change = false){
                if (this.lessons[ this.currentLesson ] && this.lessons[ this.currentLesson ].date_time[this.currentStream ]&& change) {
                    this.lessons[ this.currentLesson ].date_time[this.currentStream ].changed = false;  
                }
                this.CloseForm();
            },
            closeModalFormMissClick(e){
                let modalForm = this.$el;
                if(modalForm !== null){ 
                    let target = e.target;
                    let its_modalForm = target === modalForm || modalForm.contains(target);
                    if (!its_modalForm&& (this.add_form || this.edit_form || this.change_form || this.del_course_form )) {
                        this.CloseFormLocal();
                  }
                }
            },
            closeModalFormEsc(e){
              if(e.keyCode === 27) {
                this.CloseFormLocal();
              }
            },
            SetLesson(lesson){
              // console.log('SetLesson')
              this.currentLesson = lesson.lesson;
            },

            OpenEdit(){
                this.OpenEditForm();
            },
            updateTime(changeOpenDay){
                this.otherLessons = [];

                let openDayString = this.date_active.getFullYear() + '.' + this.date_active.getMonth() + '.' + this.open_day;
                if (changeOpenDay) {
                    // openDayString = this.date_active.getFullYear() + '.' + this.date_active.getMonth() + '.' + this.selectDay.split('.')[0];
                    openDayString = this.selectDay.getFullYear() + '.' + this.selectDay.getMonth() + '.' + this.selectDay.getDate();                
                }

                let otherStreams = [...this.streamsMy, ...this.streamsEntries];

                for(let s = 0; s < otherStreams.length; s++) {
                    let stream = otherStreams[s];
                    for (let l = 0; l < stream.lessons.length; l++) {
                        let lesson = stream.lessons[l];

                        let date = new Date(lesson.date_time);
                        let date_string = date.getFullYear() + '.' + date.getMonth() + '.' + date.getDate();

                        if(date_string === openDayString){
                            let duration = lesson.duration;

                            let hours = date.getHours();
                            let minutes = date.getMinutes();

                            let time = hours * 60 + minutes + duration;

                            let hours_end = Math.floor(time/60);
                            let minutes_end = time - hours_end * 60;

                            let val = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);
                            val += '-';
                            val += (hours_end < 10 ? '0' + hours_end : hours_end) + ':' + (minutes_end < 10 ? '0' + minutes_end : minutes_end);
                            let value = val;
                            val += ', ';
                            val += stream.name;
                            let item = {};
                            item.value = value;
                            item.val = val;
                            item.id = stream.courseId;
                            item.slug = stream.slug;
                            this.otherLessons.push(item);

                            duration = parseInt(this.lessons[this.lesson_index].duration.value.minute);

                        }
                    }
                }

                for (let i = 0; i < this.lessons.length; i++) {
                    for (let j = 0; j < this.lessons[i].date_time.length; j++) {
                        let date = this.lessons[i].date_time[j].date;
                        let date_string = this.date_active.getFullYear() + '.' + date.getMonth() + '.' + date.getDate();

                        if(date_string === openDayString){
                            let hours = parseInt(date.getHours()) < 10 ? '0' + date.getHours() : date.getHours();
                            let minutes = parseInt(date.getMinutes()) < 10 ? '0' + date.getMinutes() : date.getMinutes();
                            let time_start = hours + ':' + minutes;

                            minutes = parseInt(hours) * 60 + parseInt(minutes);
                            let duration = parseInt(this.lessons[this.lesson_index].duration.value.minute);

                            minutes += duration;
                            hours = Math.floor(minutes / 60);
                            minutes -= hours * 60;
                            if(hours < 10)
                                hours = '0' + hours;
                            if(minutes < 10)
                                minutes = '0' + minutes;

                            let time_end = hours + ':' + minutes;

                            let val = time_start + '-' + time_end;
                            let value = val;
                            if (this.course && this.course.name) {
                                val = val + ', ' + this.course.name;
                            }
                            let item = {
                                val,
                                id: this.course ? this.course.id : null,
                                value: value,
                                slug: this.course ? this.course.slug : null
                            };

                            this.otherLessons.push(item);
                        }
                    }
                }
            },

            UpdateLessonInDay(changeOpenDay){
                let les = [];
                let bef = {};
                bef.value = '00:00-00:00';

                if(this.open_day !== null) {
                    let openDay = this.open_day 
                    let before_day = new Date(this.date_active);

                    before_day.setDate( openDay - 1 )

                    let select_year = this.date_active.getFullYear();
                    let select_month = (this.date_active.getMonth() + 1) < 10 ? '0' + (this.date_active.getMonth() + 1) : (this.date_active.getMonth() + 1);
                    let select_day = openDay < 10 ? '0' + openDay : openDay;

                    let before_select_month = (before_day.getMonth() + 1) < 10 ? '0' + (before_day.getMonth() + 1) : (before_day.getMonth() + 1);
                    let before_select_day = before_day.getDate() < 10 ? '0' + before_day.getDate() : before_day.getDate();

                    let select_date = this.date_active.getFullYear() + '.' + select_month + '.' + select_day;
                    let before_select_date = before_day.getFullYear() +   '.' + before_select_month + '.' + before_select_day;

                    if (changeOpenDay) {
                        select_year = this.selectDay.getFullYear();
                        select_month = ( this.selectDay.getMonth() + 1) < 10 ? '0' + ( this.selectDay.getMonth() + 1) : ( this.selectDay.getMonth() + 1);
                        select_day = this.selectDay.getDate();

                        before_day.setDate( select_day - 1 )

                        before_select_month = (before_day.getMonth() + 1) < 10 ? '0' + (before_day.getMonth() + 1) : (before_day.getMonth() + 1);
                        before_select_day = before_day.getDate() < 10 ? '0' + before_day.getDate() : before_day.getDate();

                        select_date = select_year + '.' + select_month + '.' + select_day;
                        before_select_date = before_day.getFullYear() +   '.' + before_select_month + '.' + before_select_day;

                        // openDay= this.selectDay;

                    }

                    for (let i = 0; i < this.lessons.length; i++) {
                        for (let j = 0; j < this.lessons[i].date_time.length; j++) {
                            let date = this.lessons[i].date_time[j].date;

                            let les_month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
                            let les_day =date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                            let les_date = date.getFullYear() + '.' + les_month + '.' + les_day;

                            if (les_date === select_date) {
                                let hours = parseInt(date.getHours()) < 10 ? '0' + date.getHours() : date.getHours();
                                let minutes = parseInt(date.getMinutes()) < 10 ? '0' + date.getMinutes() : date.getMinutes();
                                let time_start = hours + ':' + minutes;

                                minutes = parseInt(hours) * 60 + parseInt(minutes);
                                minutes += parseInt(this.lessons[i].duration.value.minute);
                                hours = Math.floor(minutes / 60);
                                minutes -= hours * 60;
                                if(hours > 24 || ( hours == 24 && minutes > 0) ){ // означает что это часы на следующий день
                                    hours -= 24;
                                }

                                if(hours < 10)
                                    hours = '0' + hours;
                                if(minutes < 10)
                                    minutes = '0' + minutes;

                                let time_end = hours + ':' + minutes;
                                les.push({
                                    lesson: i,
                                    date_time: j,
                                    date_day: les_day + '.' + les_month + '.' + date.getFullYear(),
                                    value: time_start + '-' + time_end,
                                    // options: options,
                                    update: this.lessons[i].date_time[j].update,
                                    duration: this.lessons[i].duration.value.minute,
                                    streamId: this.lessons[i].date_time[j].streamId,
                                    localStreamIndex: this.lessons[i].date_time[j].localStreamIndex,
                                })
                            }
                            if (les_date === before_select_date) {
                                let hours = parseInt(date.getHours()) < 10 ? '0' + date.getHours() : date.getHours();
                                let minutes = parseInt(date.getMinutes()) < 10 ? '0' + date.getMinutes() : date.getMinutes();
                                let time_start = hours + ':' + minutes;
                                minutes = parseInt(hours) * 60 + parseInt(minutes);
                                minutes += parseInt(this.lessons[i].duration.value.minute);
                                hours = Math.floor(minutes / 60);
                                minutes -= hours * 60;
                                if(hours > 24 || ( hours == 24 && minutes > 0) ){ // означает что это часы на следующий день
                                    hours -= 24;
                                }

                                if(hours < 10)
                                    hours = '0' + hours;
                                if(minutes < 10)
                                    minutes = '0' + minutes;

                                let time_end = hours + ':' + minutes;
                                if (bef.value < (time_start + '-' + time_end))
                                  bef = {
                                      lesson: i,
                                      date_time: j,
                                      date_day: les_day + '.' + les_month + '.' + date.getFullYear(),
                                      value: time_start + '-' + time_end,
                                      // options: options,
                                      update: this.lessons[i].date_time[j].update,
                                      duration: this.lessons[i].duration.value.minute,
                                  }
                            }
                        }
                    }
                }
                this.lessons_in_day = les;
                this.lesson_in_day_before = bef;
            },
            SubmitAdd(){
                let month = this.date_active.getMonth() + 1;
                if(month < 10)
                    month = '0' + month;

                let day = this.open_day;
                if(day < 10)
                    day = '0' + day;

                let date = new Date(this.date_active.getFullYear() + '-' + month + '-' + day);
                let time = this.time.label.split(':');
                date.setHours(time[0]);
                date.setMinutes(time[1]);

                this.time = {label: '00:00', value: 0};

                this.CloseFormLocal();

                this.$parent.$parent.AddDate(date);
            },
            UpdateLessons(){
                let new_date_time = [];
                let lesson_index = 0;

                for(let i = 0; i < this.lessons_in_day.length; i++){
                    let time = this.lessons_in_day[i].value.split('-')[0].split(':');
                    let dateTime = new Date(this.lessons[this.lessons_in_day[i].lesson].date_time[this.lessons_in_day[i].date_time].date);
                    dateTime.setHours(time[0]);
                    dateTime.setMinutes(time[1]);

                    new_date_time.push({
                        index: this.lessons_in_day[i].date_time,
                        date: dateTime,
                    });

                    lesson_index = this.lessons_in_day[i].lesson
                }

                this.time = {label: '00:00', value: 0};
                this.CloseFormLocal();

                if (this.lesson_type === 3) {
                    this.$parent.$parent.UpdateDate(lesson_index, new_date_time, true);
                } else {
                    this.$parent.$parent.UpdateDate(lesson_index, new_date_time);
                }

            },
            Del(data){
                this.$parent.$parent.DelLesson(data.lesson, data.date_time);
                setTimeout(()=>{
                  this.UpdateLessonInDay(false);
                  if(!this.lessons_in_day.length)
                    this.CloseFormLocal();
                }, 100)
            },
            DelCourseModalOpnen(data){
                this.CloseFormLocal();
                this.currentLesson = data.lesson;
                this.currentStream = data.date_time;
                this.currentStreamObj = data;
                
                this.OpenDelCourseForm();
            },
            DelCourse(streamId){
                this.CloseFormLocal();
                this.$parent.$parent.DelCourseStream(streamId);
            },
            changeInputDate() {
                if ( !(this.selectDay.getMonth() == this.date_active.getMonth() ) || !(this.selectDay.getFullYear() == this.date_active.getFullYear())){
                    this.lessons[ this.currentLesson ].date_time[this.currentStream ].changed = true;   
                    this.GoTo(this.selectDay)
                }
                  
                this.updateTime(true);
                this.UpdateLessonInDay(true);

                if (this.optionsEdit.indexOf(this.value) < 0){
                  this.value = this.optionsEdit[0]
                }

            },
            changeLessonDate(data) {
                this.CloseFormLocal();

                this.currentLesson = data.lesson;
                this.currentStream = data.date_time;
                this.currentLessonId = this.lessons[ this.currentLesson ].date_time[this.currentStream ].id

                this.value = data.value;

                this.titleStream = this.calendarText.stream + ' ' + Number(data.date_time + 1) + '    ' + this.calendarText.lesson + ' ' + Number(data.lesson + 1);

                let date = this.date_active
                date.setDate(this.open_day)

                this.selectDay = date
                this.OpenChangeForm();
            },
            changeDate() {

                this.CloseFormLocal()
                let date = this.selectDay
                let time = this.value.split('-')[0].split(':');
                date.setHours(time[0]);
                date.setMinutes(time[1]);

                let new_date_time = {
                    lesson_index: this.currentLesson, 
                    id: this.currentLessonId,
                    date: date,
                };

                this.$parent.$parent.UpdateDateById( new_date_time, this.lesson_type === 3);

                this.error = false;
            }
        }
    }
</script>

<style lang="sass">

.t-otherLessonContainer
  width: 100%
  *
    width: 100%

.t-addLesson
  position: absolute
  z-index: 13
  top: 50%
  right: 0
  left: 0
  width: 320px
  margin: auto
  transform: translateY(-50%)
  @extend %substrate
  padding: 16px
  &__deleteBtn
    position: absolute
    right: 16px
    bottom: 16px
    background: transparent
    border: none
    outline: none
  &__del
    // position: absolute
    // right: 0
    // bottom: 0
    // float: right
    width: 40px
    height: 40px
    display: flex
    align-items: center
    justify-content: center
    background: transparent
    border: none
    outline: none
    cursor: pointer
    &:first-of-type
      margin-left: auto
  &__close
    position: absolute
    top: 12px
    right: 16px
    width: 40px
    height: 40px
    cursor: pointer
    background: url('/img/close.png') no-repeat center
  &__title
    width: 100%
    white-space: pre-wrap
    font-weight: 600
    font-size: 16px
    color: $black
    &-text
      margin-bottom: 24px
  &__textStream
    margin-bottom: 24px
    font-size: 16px
    color: $black
    width: 100%
    white-space: pre-wrap
  &__other
    display: block
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    margin-bottom: 5px
    width: 100%
    transition: color .3s
    &:last-child
      margin-bottom: 0
    @media(min-width: 770px)
      &:hover
        color: $blue
  h2
    margin-bottom: 18px
  .t-input
    display: flex
    flex-wrap: wrap
    align-items: center
    label
      flex: none
      width: 100%
    .v-select
      width: 168px
      flex: none
      margin-right: 8px
      .open-indicator
        background-image: url('/img/time.png')
    span
      flex: 1

.t-input__change
  position: relative

.t-calendar_changeDate
  width: 300px
  min-width: 300px
  position: absolute
  top: 70px
  left: -6px
  z-index: 5

@media(max-width: 769px)
  .t-addLesson
    position: fixed
    top: calc(50% - 36px)
    max-height: calc(100vh - 72px)
    overflow-y: auto
    &__wrapper
      max-height: 50vh
      overflow-y: auto
      margin: 0 0 24px
      .t-input:last-child
        margin-bottom: 0
  .t-otherLessonContainer
    width: 100%
    position: relative
    > div
      max-height: 185px
      overflow-y: auto
      width: 100%
      padding: 10px 0
    &:before 
      content: ''
      position: absolute
      top: -1px
      left: 0
      height: 10px
      width: 100% 
      background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%)
    &:after
      content: ''
      position: absolute
      bottom: -1px
      left: 0
      height: 10px
      width: 100%
      background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)
</style>


// WEBPACK FOOTER //
// src/vue_components/Calendar/Create/ModalForm.vue